module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-827f36bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageTitle.vue
// module id = 1848
// module chunks = 1